import {content} from './content';
import {createTranslationFn} from './utils';
import type {ContentKey} from './types';

export {useTranslation, TranslationProvider} from './react/TranslationProvider';
export {Translation} from './react/Translation';

export {TranslationContext} from './context';

export type {ContentKey, DesignerTranslationFn} from './types';

export const designerContent = content;

/**
 * ESCAPE HATCH to access the `t` function where hook or React components are not available.
 * This is discouraged because it assumes that the provided `designerContent` will always be
 * static. This will not be the case if, for example, translations are loaded separately based on
 * language before the content is loaded to the Designer.
 */
export const designerTranslation = {
  t: createTranslationFn<ContentKey>(content),
} as const;
